<template>
    <div>
        <navbar1></navbar1>
        <div class="__outsourcebg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-9 col-sm-9">
                        <!-- <p class="__welf1">Outsource your engineering team with us</p> -->
                        <p class="__welf1">Findworka is the future of digital work.</p>
                        <p class="__welf2">We host the largest network of verified developers and lead the digital transformation of enterprises around the world by equipping software talents, startups and enterprises with the project management and productivity tools that they need to build mission-critical solutions.</p>
                    </div>
                    <div class="col-lg-4 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>

        <div class="__proicon">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 col-md-9 col-sm-9">
                        <p class="__hirep">Our Story</p>
                        <p class="__hirep1">We launched in 2016 as a platform for hiring artisans and semi-skilled workers.<br><br>In 2017, we morphed into a digital services-only freelance platform where users could find, connect with, hire and pay diversely skilled digital professionals. We offered a secured escrow service and our users loved it.</p>

                        <p class="__hirep1">Currently, we build technology products and extend the engineering capacities of ambitious companies using our network of pre-vetted talents.<br><br>
                        By tech products, we mean desktop apps, web portals, mobile apps, animations, graphic designs, AI and blockchain solutions, copywriting and more. We have a tested and reliable project management approach that combines the best of agile and scrum on our products. From start to finish, we ensure that the development experience is as satisfying as the completed product.<br><br>
                        Our mission is to empower today’s companies and workers with the technology and opportunities needed to succeed in the evolving digital economy.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <div  class="__group">
                        <!-- <img src="../assets/img/group.png" class="img-responsive"> -->
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group1"></div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group2"></div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group21"></div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group22"></div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group23"></div>
                    <div class="__group24"></div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="__group3"></div>
                </div>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Our Services</p>
                <p class="__wedop1">Findworka builds amazing software products, whether it is just an MVP or the nth version of your platform.<br> We also supply development talents for your contract and full-time position.</p>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/software-development.png" class="__hidimg">
                        <p class="__hidep">Software Development</p>
                        <p class="__hidep1">Whatever web application, or development we have the guys skilled.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/product-design.png" class="__hidimg">
                        <p class="__hidep">UX & Product Design</p>
                        <p class="__hidep1">From screen to screen, we make brilliant designs that tell compelling stories.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/project-management.png" class="__hidimg">
                        <p class="__hidep">Project Management</p>
                        <p class="__hidep1">Take your project from start to finish and ensure that you have a world-class product.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/outsourcing.png" class="__hidimg">
                        <p class="__hidep">Talent Outsourcing</p>
                        <p class="__hidep1">Our Pros are elite squad of pre-vetted technical talents.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="__prodbg">
            <div class="container">
                <p class="__ourpro">Our Team</p>
                <p class="__ourpro1">Our team is made up of affable and competent people who are passionate about building tech products and helping ambitious people and companies succeed. We are smart, talented, and sure do know how to have fun!</p>
                <p class="__ourpro2">Our mission is to empower today’s companies and workers with the technology and<br>opportunities needed to succeed in the evolving digital economy.<br>- CEO @DeleBaks</p>
                <br><br>

                <div class="__abotflex">
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/DELE.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/delebakare/?originalSubdomain=ng" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/DeleBaks" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Dele Bakare</p>
                        <p class="__proicp1">Chief Executive Officer</p>
                    </div>
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/WILFRED.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/wilfred-ekpo-50256021/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/wilfred_ekpo" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Wilfred Ekpo</p>
                        <p class="__proicp1">Chief Operations Officer</p>
                    </div>
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/BABATUNDE.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/tunde-yusuf/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/iamtundeyusuf" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Tunde Yusuf</p>
                        <p class="__proicp1">Engineering Manager</p>
                    </div>
                    
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/ABIMBOLA.jpg" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/odugbesan-abimbola-310107105/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/wizubizu" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Abimbola Odugbesan</p>
                        <p class="__proicp1">Senior Front-end Developer</p>
                    </div>
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/oyin.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/oyinkansola-subair-0a1b86a0" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/SubairOyin" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Oyinkansola Subair</p>
                        <p class="__proicp1">Finance Manager</p>
                    </div>
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/HELEN.png" class="img-responsive"/>
                            <!-- <div class="__prosicons">
                                <a href="http://linkedin.com/in/mutiat-atolagbe-acipm-hrpl-0392ba81" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/its_muteehat" target="_blank"><i class="fab fa-twitter"></i></a>
                            </div> -->
                        </div>
                        <p class="__proicp">Helen Ojumu</p>
                        <p class="__proicp1">People Operations Officer</p>
                    </div>
                    
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/OMOSEFE.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Ogbebor Clementina Omosefe</p>
                        <p class="__proicp1">Project Associate Intern</p>
                    </div>
                    
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/MONDAY.jpg" class="img-responsive"/>
                            <!-- <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/ogunniran-olusola-99a09669/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/sasonxg" target="_blank"><i class="fab fa-twitter"></i></a>
                            </div> -->
                        </div>
                        <p class="__proicp">Victor Monday A.</p>
                        <p class="__proicp1">Fullstack Developer</p>
                    </div>
                    
                    
                    <div class="__aboinfl">
                        <div class="__imgcard">
                            <img src="../assets/img/LANRE.jpg" class="img-responsive"/>
                            <div class="__prosicons">
                                <!-- <a href="https://www.linkedin.com/in/lanre-bakare/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Olanrewaju Bakare</p>
                        <p class="__proicp1">Social Media Manager</p>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col-lg-7 col-md-7">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/VICTOR.jpg" class="img-responsive"/>
                                </div>
                                <p class="__proicp">Adedini Victor</p>
                                <p class="__proicp1">Product Designer</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/BOYE.png" class="img-responsive"/>
                                    <div class="__prosicons">
                                    </div>
                                </div>
                                <p class="__proicp">Adeboye Ademiluyi</p>
                                <p class="__proicp1">Graphic Designer</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/ABIGAIL.png" class="img-responsive"/>
                                </div>
                                <p class="__proicp">Adeniran Oloruntoyin Abigail</p>
                                <p class="__proicp1">Product Designer</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/OMOSEFE.jpg" class="img-responsive"/>
                                </div>
                                <p class="__proicp">Ogbebor Clementina Omosefe</p>
                                <p class="__proicp1">Project Associate Intern</p>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/IRENE.png" class="img-responsive"/>
                                </div>
                                <p class="__proicp">Irene Okafor</p>
                                <p class="__proicp1">Developer Intern</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-7 col-md-7">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <div class="__imgcard">
                                    <img src="../assets/img/KINGSLEY.png" class="img-responsive"/>
                                </div>
                                <p class="__proicp">Kingsley Nwoga</p>
                                <p class="__proicp1">Developer Intern</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-4"></div>
                        </div>
                    </div>
                </div> -->
                <br><br>

                <p class="__ourpro" style="color: #ffffff;">Board of advisors</p>
                <p class="__ourpro1">We are well-advised by experienced entrepreneurs who are seasoned in various fields and have built<br> successful businesses.</p>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/bosun.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Bosun Tijani</p>
                        <p class="__proicp1">CEO - CCHub Nigeria</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/Nadu-Denloye.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Dr Nadu Denloye</p>
                        <p class="__proicp1">Past MD - Telnet</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/Seun-Onigbinde.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Oluseun Onigbinde</p>
                        <p class="__proicp1">Lead Partner, BudgIT</p>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/nana_findworka.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Nana Milagrosa Utomi</p>
                        <p class="__proicp1">CEO - Mabatpro</p>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/kolawole-ayeye.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Kola Ayeye</p>
                        <p class="__proicp1">CEO - GDL</p>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/neil_findworka.jpg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Neil Devani</p>
                        <p class="__proicp1">Investor, Singularity Holdings</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <p class="__ourep">Our projects</p>
            <p class="__hirep1">Our clientele comprises some of the most progressive companies across the globe. We work with<br> businesses spanning different sectors but having the same desire - the need for great tech. We listen to our<br> clients and with distinctive collaboration, transform their big ideas into exceptional products.<br>We work with the best and deliver the best, such that when your product launches, you are guaranteed two<br> things - smiles and satisfaction.</p><br><br>
            <router-link to="/project" class="__sthringlink">See our projects <img src="../assets/img/right-arrow.svg"> </router-link>
        </div>

        <div class="__hirbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-laptop"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Build your product</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                                <router-link to="/build" class="btn __startbtn">Start now</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div class="__midline hidden-xs"></div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-code"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Hire a developer</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">Hire from our network of pre-vetted and handpicked programming talents for your full-time and contract engagements.</p>
                                <a href="https://hire.findworka.com" target="__blank" class="btn __startbtn">Hire a dev</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import navbar1 from '../components/navbar1';


export default {
    components: { navbar1,},
}
</script>

<style scoped>
@import '../assets/css/about';
</style>


// WEBPACK FOOTER //
// src/components/about.vue